module.exports = __webpack_public_path__ + "static/media/multymuro.6aa56f92.pdf";